import api from '@/api'

const { $academic, $pricing, $core } = api;
export const { $ceos, $careers } = $academic;
export const { $zones, $types } = $pricing;
export const { $users, $roles } = $core;
